import React from 'react';
import classnames from 'classnames';
import { getIconForVariant } from './queries';
import styles from './index.module.scss';

export type HeaderProps = {
  children?: string | React.ReactNode;
  'data-test-id'?: string;
  className?: string;
  variant?: 'default' | 'success' | 'error' | 'info' | 'warning';
};

function Header({
  children,
  'data-test-id': dataTestId,
  className = '',
  variant = 'default',
}: React.PropsWithChildren<HeaderProps>) {
  const iconClassNames = classnames(
    styles.page__header__icon,
    styles[`page__header__icon__${variant}`],
  );
  return (
    <div
      data-test-id={`${dataTestId}`}
      className={`${styles.page__header} ${className}`}
    >
      {variant !== 'default' && (
        <div className={iconClassNames} id="variant-icon">
          {getIconForVariant(variant)}
        </div>
      )}
      <div className={`${styles.page__header__content}`}>{children}</div>
    </div>
  );
}

export default Header;
